import { render, staticRenderFns } from "./PsotAdd.vue?vue&type=template&id=79437f33&scoped=true&"
import script from "./PsotAdd.vue?vue&type=script&lang=js&"
export * from "./PsotAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79437f33",
  null
  
)

export default component.exports